/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// var NS = '.pdpTabsVisibility';

// function initTabsVisibility() {
//   var $tabs = $('.pdp-tabs');
//   var $target = $('#our_promise');
//   if (!$tabs.length || !$target.length) return;

//   $(window).on('scroll' + NS, function () {
//     $tabs.toggleClass('is-visible', $target[0].getBoundingClientRect().top <= 140);
//   }).trigger('scroll' + NS);
// }

// function destroyTabsVisibility() {
//   $(window).off(NS);
// }

// destroyTabsVisibility();
// initTabsVisibility();

// $(document).on('shopify:section:load', function () {
//   destroyTabsVisibility();
//   initTabsVisibility();
// });

var NS = '.pdpTabsVisibility';
var OFFSET = 140;

function initTabsVisibility() {
  var $tabs = $('.pdp-tabs');
  var $start = $('#our_promise');
  var $end = $($('.pdp-tabs__link').last().attr('data-href'));
  if (!$tabs.length || !$start.length || !$end.length) return;

  $(window).on('scroll' + NS, function () {
    var startTop = $start[0].getBoundingClientRect().top;
    var endBottom = $end[0].getBoundingClientRect().bottom;
    $tabs.toggleClass('is-visible', startTop <= OFFSET && endBottom > OFFSET);
  }).trigger('scroll' + NS);
}

function destroyTabsVisibility() {
  $(window).off(NS);
}

destroyTabsVisibility();
initTabsVisibility();

$(document).on('shopify:section:load', function () {
  destroyTabsVisibility();
  initTabsVisibility();
});
// ====================================================================

$(document).ready(function(){


  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
 
  if(document.querySelectorAll('[data-custom-reveal]').length){

    let targets = document.querySelectorAll('[data-custom-reveal]');
  
    if (!targets.length) return;
  
    let observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(entry => {
          console.log(entry.intersectionRatio);
          if (entry.intersectionRatio >= 0.5) {
            const target = entry.target;
  
            // Mark the element as visible
            $(target).attr('data-visible', 'true');
    
            // 🔸 Only animate if this is the benefits section
            if (target.classList.contains('benefits-highlights-section')) {
              animateBenefitsSection(target);
            }
          }
        });
      },
      {
        threshold: 0.5
      }
    );
  
    targets.forEach(target => observer.observe(target));
  
    function animateBenefitsSection(section) {
      const items = section.querySelectorAll('.benefits-highlight-li');
    
      // Animate from bottom to top
      const reversedItems = Array.from(items);
    
      reversedItems.forEach((el, index) => {
        setTimeout(() => {
          el.classList.add('revealed');
        }, index * 300); // Stagger effect
      });
    }
  }

  // setTimeout(function () {
    
  // }, 000);

  $(".testimonial-secondary-list.sliderr").slick({
      arrows:false,
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".featured-product-sec-media-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $(".product-meta-title-icon-slider").slick({
      arrows:false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
  });

  $('body').on('click','.featured-product-sec-atc-button', function(){
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var items = [];
    var variantId = _this.data('variant-id'); 
    items.push({
          quantity: 1,
          id: variantId
        });
    var data = {items};
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {items},
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          //alert(response.description);
        },
        success: function() {
          _this.removeAttr("disabled", "disabled");
          _this.removeAttr("aria-busy", "true");
          document.getElementById('mini-cart').open = true; 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
  });

  $('body').on('click','.trial-pack-model .close_popup', function(){
    document.querySelector('.trial-model-overlay').classList.remove('is-active');
    document.querySelector('.trial-pack-model').classList.remove('is-active');
  });

  $('body').on('click','[data-product-add-to-cart-button-custom]', function(e){
    e.preventDefault;
    var _this = $(this);
    var thisform = $(this).closest('.shopify-product-form');
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: thisform.serialize(),
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          //alert(response.description);
        },
        success: function() {
          _this.removeAttr("disabled", "disabled");
          _this.removeAttr("aria-busy", "true");
          document.getElementById('mini-cart').open = true; 
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }
      });
  });

  const container = document.querySelector('.block-swatch-list-wrap.hasleft .block-swatch-list');
  if(container){
    container.scrollLeft = container.scrollWidth;
  }

  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  //get cookie
  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }
  
  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    $('body').attr('data-cartcount',cart.item_count);
    if($('body').hasClass('template-product')){
      var tags = $('body').attr('data-tags').split(',');
      if(tags.includes('except_offer')){
        const currentPid = $('body').attr('data-pid');
        const matchedItems = cart.items.filter(item => item.product_id == currentPid);
        console.log(matchedItems)
        if(matchedItems.length > 0){
          $('.product .product-form__payment-container #AddToCart,#StickyAddToCart').attr('type','button').attr('disabled','disabled').removeAttr('data-product-add-to-cart-button');
        }else{
          $('.product .product-form__payment-container #AddToCart,#StickyAddToCart').attr('type','submit').removeAttr('disabled').attr('data-product-add-to-cart-button',true);
        }
      }
      
      
      console.log(cart);
    }
  });    

  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute

    if (!text) return; // prevent copying empty

    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });

  // VIDEOLIST SECONDARY
   $('.multi_video-list').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: false,   // important for mobile
      pauseOnFocus: false,   // avoid pausing on tap
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            dots: false,
            pauseOnHover: false,
            pauseOnFocus: false
          }
        }
      ]
  });
  $('.multi_video-list').on('touchend', function () {
    $(this).slick('slickPlay');
  });

   $('.customer-wall_wrapper').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 4000,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            dots: false
          }
        }
      ]
  });

  $('.condition_apply-button').click(function(){
    $(this).toggleClass('active');
   $(this).closest('.product-our-promise-wrap').find('.condition_apply-content').slideToggle();
  });

  if(location.href.includes('#customer-created')){
    console.log("Customer registered via AJAX");

    dataLayer.push({
      'event': 'signup_successful', //pass the event name only at the time of sign up
      'user_id': window.themeVariables.customer.id, //dynamic unique value of logged in user
      'login_status': 'logged_in',//if the user is logged in then we need to pass the status as logged_in otherwise not_logged_in
    });
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }

  if(location.href.includes('#customer-loggedin')){
    console.log("Customer loggedin via AJAX");

    dataLayer.push({
      'event': 'login_successful', //pass the event name only at the time of sign up
      'user_id': window.themeVariables.customer.id, //dynamic unique value of logged in user
      'login_status': 'logged_in',//if the user is logged in then we need to pass the status as logged_in otherwise not_logged_in
    });
    history.replaceState(
      null,
      document.title,
      window.location.pathname + window.location.search
    );
  }

  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let form = event.target;
    console.log('PDP view item fired')
    dataLayer.push({ ecommerce: null });  // clear the previous ecommerce object.
    dataLayer.push({
      event: "view_item",
      ecommerce: {
        item_list_name: 'Products page',
        items: [{
          item_name: $(form).attr("data-itemname"),
          item_id: `shopify_IN_${$(form).attr("data-itemid")}_${variant.id}`,
          item_variant: variant.public_title,
          item_brand: 'petchef',
          price: variant.price,
          currency: 'INR',
          item_list_name: 'products page',
          quantity: 1
        }]
      }
    });
  });

  $('body').on('click', '.mini-cart-footer-total', function() {
    $(this).toggleClass('active');
    $(this).closest('.mini-cart__drawer-footer').find('.cart-payment-summary_main').slideToggle();
  });
  $(function () {
    var $win = $(window);

    function toggleSticky() {
      $('body').toggleClass('sticky-form-visible', $win.scrollTop() > 10);
    }

    $win.on('scroll', toggleSticky);
    toggleSticky();
  });

  $('body').on('click', '.product-meta_accordion-item_title', function (e) {
    $(this).toggleClass('active');
    $(this).next('.product-meta_accordion-item_content').slideToggle();
  
    // Toggle aria-expanded attribute
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("register-customer");
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // optional: disable button / show loader
    form.classList.add("is-loading");

    const formData = new FormData(form);

    try {
      const response = await fetch("/account", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "text/html"
        }
      });

      const html = await response.text();

      // Parse returned HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // SUCCESS → Shopify redirects to /account
      if (response.redirected || doc.querySelector("a[href='/account/logout']")) {
        window.location.href = "/#customer-created";
        return;
      }

      // ERROR → extract Shopify error banner
      const newErrorBanner = doc.querySelector(".form__banner");
      const oldErrorBanner = form.querySelector(".form__banner");

      // remove existing error
      if (oldErrorBanner) oldErrorBanner.remove();

      // inject new error (exact Shopify HTML)
      if (newErrorBanner) {
        form.prepend(newErrorBanner);
      }

    } catch (err) {
      console.error("Register error", err);
    } finally {
      form.classList.remove("is-loading");
    }
  });
});

if($('#pudding').length > 0){
  var counted = 0;
  function counter() {
    var oTop = $('#pudding').offset().top - window.innerHeight;
    if (counted == 0 && $(window).scrollTop() > oTop) {
      $('.pudding-section-item-num-count').each(function() {
        var $this = $(this),
          countTo = $this.attr('data-count'),
          hasPercentage = countTo.includes('%'); // Check if % exists
        // console.log('countTo', countTo);
        $({
          countNum: $this.text()
        }).animate({
            countNum: countTo
          },
          {
            duration: 3000,
            easing: 'swing',
            step: function() {
              $this.text(Math.floor(this.countNum) + (hasPercentage ? "%" : ""));
            },
            complete: function() {
              $this.text(this.countNum + (hasPercentage ? "%" : ""));
              //alert('finished');
            }
          });
      });
      counted = 1;
    }
  }
  $(document).ready(counter);
  $(window).on('load', counter);
  $(window).on('scroll', counter);
}

$(document).ready(function(){
  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.applied_couponWrapper').find('.applied_coupon-item');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    return discountCodes;
  }

  function applied_code(discountCodeValue, _this, sectionId){
    console.log('0000',discountCodeValue, _this, sectionId)
    var existingDiscountsValue = existingDiscounts();
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    console.log('111111111111111')
    
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');
        $('.cart-offer-coupon_applied-message').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        $(_this).parents('.product-meta_offers-item').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        setTimeout(function(){
          $('.applied_code_error').remove();
        },2000);
        return;
      }
      
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      // $(_this).removeClass('loading');
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
    });
  }
  

  $('body').on('keyup','.cart-offer-coupon_input-field', function(){
    if($(this).val() != ''){
     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').addClass('active'); 
    }else{
     $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_apply-button').removeClass('active');
    }    
  });
  $('body').on('click','.cart-offer-coupon_apply-button.active', function(){
    var _this  = this;
    var discountCodeValue = $(this).closest('.cart-offer-coupon_input').find('.cart-offer-coupon_input-field').val();
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    if(discountCodeValue == ''){
      _this.closest('.cart-offer-coupon_input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','.coupon_offer-item_code-copy', function(){
    var _this  = this;
    var discountCodeValue = $(this).attr('coupon');
    var sectionId = $(_this).closest('cart-drawer').attr('section');

    $(_this).removeAttr('disabled');                                    
    $(_this).removeAttr('loading'); 
    $(_this).removeClass('loading');

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','[data-removecode]', function(){
    var _this  = this;
    console.log('hhiiihi')
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).closest('.applied_coupon-item').attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    console.log('existingDiscountsValue:', existingDiscountsValue);

    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // console.log(parsedHtml);
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());

      $(_this).removeAttr('disabled');                                    
      $(_this).removeAttr('loading'); 
      $(_this).removeClass('loading');
      
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
    });
  });
});

// -------------------------------------------------------------------------------------------
(function ($) {
  'use strict';
})(jQuery);

// function initTabs() {
//   var $tabs = $('[data-pdp-tabs]');
//   if (!$tabs.length) return;

//   var $links = $tabs.find('.pdp-tabs__link');
//   var isClickScrolling = false;

//   // Safe lookup — an anchor like "#2col" would crash $() as a selector
//   function target(hash) {
//     var el = document.getElementById(hash.replace('#', ''));
//     return el ? $(el) : $();
//   }

//   // Hide tabs pointing at sections that aren't on this page
//   function pruneLinks() {
//     $links.each(function () {
//       var exists = target($(this).attr('href')).length > 0;
//       $(this).toggleClass('is-hidden', !exists);
//     });

//     // Keep only the live ones for scrolling + scroll-spy
//     $links = $links.filter(':not(.is-hidden)');

//     // Nothing left to link to — drop the whole strip
//     $tabs.toggleClass('is-empty', $links.length === 0);
//   }

//   function offsetTop() {
//     return $tabs.outerHeight() + ($tabs.offset().top - $(window).scrollTop());
//   }

//   function setActive(hash) {
//     $links.removeClass('is-active');
//     $links.filter('[href="' + hash + '"]').addClass('is-active');
//   }

//   function scrollToSection(hash) {
//     var $target = target(hash);
//     if (!$target.length) return;

//     isClickScrolling = true;
//     setActive(hash);

//     $('html, body').stop().animate(
//       { scrollTop: $target.offset().top - offsetTop() },
//       400,
//       function () {
//         isClickScrolling = false;
//       }
//     );
//   }

//   function onScroll() {
//     if (isClickScrolling) return;

//     var line = $(window).scrollTop() + offsetTop() + 10;
//     var current = '';

//     $links.each(function () {
//       var hash = $(this).attr('href');
//       var $target = target(hash);
//       if ($target.length && $target.offset().top <= line) {
//         current = hash;
//       }
//     });

//     if (current) {
//       setActive(current);
//     } else {
//       $links.removeClass('is-active');
//     }
//   }

//   pruneLinks();
//   if (!$links.length) return;

//   // Click a tab
//   $links.off('click.pdpTabs').on('click.pdpTabs', function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     scrollToSection($(this).attr('href'));
//     history.replaceState(null, '', $(this).attr('href'));
//   });

//   $(window).off('scroll.pdpTabs resize.pdpTabs').on('scroll.pdpTabs resize.pdpTabs', onScroll);

//   // Landing on the page with #ingredients already in the URL
//   if (window.location.hash && $links.filter('[href="' + window.location.hash + '"]').length) {
//     scrollToSection(window.location.hash);
//   } else {
//     onScroll();
//   }
// }

// $(document).ready(initTabs);
// $(window).on('load', initTabs);

// $(document).on('shopify:section:load shopify:block:select', function (e) {
//   if ($(e.target).is('[data-pdp-tabs]') || $(e.target).find('[data-pdp-tabs]').length) {
//     initTabs();
//   }
// });
function initTabs() {
  var $tabs = $('[data-pdp-tabs]');
  if (!$tabs.length) return;

  var $links = $tabs.find('.pdp-tabs__link');
  var isClickScrolling = false;

  // Safe lookup — an anchor like "#2col" would crash $() as a selector
  function target(hash) {
    if (!hash) return $();
    var el = document.getElementById(hash.replace('#', ''));
    return el ? $(el) : $();
  }

  // Hide tabs pointing at sections that aren't on this page
  function pruneLinks() {
    $links.each(function () {
      var exists = target($(this).data('href')).length > 0;
      $(this).toggleClass('is-hidden', !exists);
    });

    // Keep only the live ones for scrolling + scroll-spy
    $links = $links.filter(':not(.is-hidden)');

    // Nothing left to link to — drop the whole strip
    $tabs.toggleClass('is-empty', $links.length === 0);
  }

  function offsetTop() {
    return $tabs.outerHeight() + ($tabs.offset().top - $(window).scrollTop());
  }

  function setActive(hash) {
    $links.removeClass('is-active');
    $links.filter('[data-href="' + hash + '"]').addClass('is-active');
  }

  function scrollToSection(hash) {
    var $target = target(hash);
    if (!$target.length) return;

    isClickScrolling = true;
    setActive(hash);

    $('html, body').stop().animate(
      { scrollTop: $target.offset().top - offsetTop() },
      400,
      function () {
        isClickScrolling = false;
      }
    );
  }

  function onScroll() {
    if (isClickScrolling) return;

    var line = $(window).scrollTop() + offsetTop() + 10;
    var current = '';

    $links.each(function () {
      var hash = $(this).data('href');
      var $target = target(hash);
      if ($target.length && $target.offset().top <= line) {
        current = hash;
      }
    });

    if (current) {
      setActive(current);
    } else {
      $links.removeClass('is-active');
    }
  }

  pruneLinks();
  if (!$links.length) return;

  // Click a tab
  // Click a tab
  $links.off('click.pdpTabs').on('click.pdpTabs', function (e) {
    e.preventDefault();
    e.stopPropagation();
    scrollToSection($(this).data('href'));
  });

  $(window).off('scroll.pdpTabs resize.pdpTabs').on('scroll.pdpTabs resize.pdpTabs', onScroll);

  // Landing on the page with #ingredients already in the URL
  if (window.location.hash && $links.filter('[data-href="' + window.location.hash + '"]').length) {
    scrollToSection(window.location.hash);
  } else {
    onScroll();
  }
}

$(document).ready(initTabs);
$(window).on('load', initTabs);

$(document).on('shopify:section:load shopify:block:select', function (e) {
  if ($(e.target).is('[data-pdp-tabs]') || $(e.target).find('[data-pdp-tabs]').length) {
    initTabs();
  }
});


// ==========================================================================================
var NAMESPACE = '.whyFreshTabs';
var SELECTOR = '[data-why-fresh-tabs]';

function activate($root, index) {
  var $tabs = $root.find('.why-fresh-tabs__tab');
  var $panels = $root.find('.why-fresh-tabs__panel');

  $tabs.each(function (i) {
    var isActive = i === index;
    $(this)
      .attr('aria-selected', isActive ? 'true' : 'false')
      .attr('tabindex', isActive ? '0' : '-1');
  });

  $panels.each(function (i) {
    if (i === index) {
      $(this).removeAttr('hidden');
    } else {
      $(this).attr('hidden', 'hidden');
    }
  });
}

function initOne() {
  var $root = $(this);
  if ($root.data('wftInit')) return;
  $root.data('wftInit', true);

  var $tabs = $root.find('.why-fresh-tabs__tab');

  $tabs.on('click' + NAMESPACE, function () {
    activate($root, $tabs.index(this));
  });

  $tabs.on('keydown' + NAMESPACE, function (event) {
    var key = event.key;
    var current = $tabs.index(this);
    var next = null;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      next = (current + 1) % $tabs.length;
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      next = (current - 1 + $tabs.length) % $tabs.length;
    } else if (key === 'Home') {
      next = 0;
    } else if (key === 'End') {
      next = $tabs.length - 1;
    }

    if (next === null) return;

    event.preventDefault();
    activate($root, next);
    $tabs.eq(next).trigger('focus');
  });

  activate($root, 0);
}

function destroyOne() {
  var $root = $(this);
  $root.find('.why-fresh-tabs__tab').off(NAMESPACE);
  $root.removeData('wftInit');
}

function init(scope) {
  $(scope).find(SELECTOR).addBack(SELECTOR).each(initOne);
}

function destroy(scope) {
  $(scope).find(SELECTOR).addBack(SELECTOR).each(destroyOne);
}

$(function () {
  init(document);
});

$(document).on('shopify:section:load', function (event) {
  init(event.target);
});

$(document).on('shopify:section:unload', function (event) {
  destroy(event.target);
});

// ============================================================
$(document.body).on('click', '.product-sticky-form__selected-variant', function () {
  const $target = $('.product-form__variants');
  if (!$target.length) return;

  const offset = $('.header--sticky').outerHeight() || 0;

  $('html, body').animate({
    scrollTop: $target.offset().top - offset - 100
  }, 400);
});